<template>
  <el-container>
    <el-header class="sub-header" style="height: 2.5rem">
      <el-row type="flex" justify="space-between">
        <el-col>
          <el-radio-group v-if="setting.isSimple" v-model="condition.term" class="right-pad" @change="init" size="small" fill="#909399">
            <el-radio-button label="长期">长期</el-radio-button>
            <el-radio-button label="临时">临时</el-radio-button>
          </el-radio-group>
          <el-dropdown v-if="!readonly" split-button type="primary" @click="special('医技')" @command="special" size="small">
            <i class="el-icon-scissors" /> 医技
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="!setting.hideHerable" command="草药"><i class="el-icon-cherry" /> 草药</el-dropdown-item>
              <el-dropdown-item v-if="!setting.hideTransfer" command="转科"><i class="el-icon-refresh" /> 转科</el-dropdown-item>
              <el-dropdown-item command="离院"><i class="el-icon-finished" /> 离院</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown v-if="!readonly" split-button type="success" @click="action('下达')" @command="action" size="small" class="left-pad">
            <span type="text" size="mini"><i class="el-icon-smoking" /> 下达</span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="指示停止" icon="el-icon-switch-button" class="danger">停止</el-dropdown-item>
              <el-dropdown-item command="取消" icon="el-icon-no-smoking" class="danger">取消</el-dropdown-item>
              <el-dropdown-item command="作废" icon="el-icon-no-smoking" class="danger">作废</el-dropdown-item>
              <el-dropdown-item v-if="!setting.hidePause" command="暂停" icon="el-icon-video-pause" class="warning">暂停</el-dropdown-item>
              <el-dropdown-item v-if="!setting.hidePause" command="重启" icon="el-icon-video-play" class="primary">启用</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown split-button type="warning" @click="print" @command="tmplCmd" size="small" class="left-pad">
            <i class="el-icon-printer" /> 打印
            <el-dropdown-menu slot="dropdown" v-if="!readonly">
              <el-dropdown-item command="checkApp" icon="el-icon-printer">检验申请单</el-dropdown-item>
              <el-dropdown-item command="checkQr" icon="el-icon-printer">检验条码</el-dropdown-item>
              <!-- <el-dropdown-item command="select" icon="el-icon-folder-opened">应用模板</el-dropdown-item>
              <el-dropdown-item command="save" icon="el-icon-folder-checked">保存模板</el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown split-button type="danger" @click="tmpl.showSelector = true" @command="tmplCmd" size="small" class="left-pad">
            <i class="el-icon-notebook-2" />医嘱模板引用
            <el-dropdown-menu slot="dropdown" v-if="!readonly">
              <el-dropdown-item command="save" icon="el-icon-folder-checked">保存医嘱模板</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <hic-dict-selector v-if="!readonly" dict-type="Storehouse" v-model="storehouseCode" class="edit-input left-pad" auto />
          <!-- <el-select v-model="storehouseCode" placeholder="默认药房" size="small" class="edit-input left-pad" title="默认药房">
            <el-option v-for="item in StorehouseOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select> -->
          <!-- <hic-dict-selector style="width: 200px;margin-left: 10px;" @change="(e) => changeCheck(e, row, 'claimType')" dict-type="Storehouse" v-model="condition.storehouseCode" /> -->
        </el-col>
        <el-col class="right">
          <el-date-picker @change="dateChange" style="width: 270px" size="small" v-model="meta.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
          <el-input class="condition-wide left-pad" v-model="condition.keyword" placeholder="医嘱内容" size="small" v-on:keyup.enter.native="init" clearable @clear="init">
            <el-button type="info" :loading="meta.loading" slot="append" icon="el-icon-search" @click="init"> </el-button>
          </el-input>
        </el-col>
      </el-row>
    </el-header>

    <AdviceTable ref="adviceTable" :condition="condition" :storehouse-code="storehouseCode" @save="addAdvice" @load="init" @action="action" :readonly="readonly" />

    <!-- <template v-if="$refs.adviceTable"> -->
    <hic-ml-dialog :visible.sync="meta.showMl" :patient="entity" @ok="mlSelected" />
    <hic-herbal-dialog :visible.sync="meta.showHerbal" :new-item-fun="proto" @ok="hearbalSelected" />

    <SpecialEditor :visible.sync="meta.showSpecial" :type="meta.specialType" :hospitalization="entity" @ok="addAdvice" />
    <TemplateSelector :visible.sync="tmpl.showSelector" @close="init" />
    <TemplateEditor :visible.sync="tmpl.showEditor" :entity="tmpl.entity" />
    <PrintDialog :visible.sync="meta.showPrint" :hospitalization="entity" :type="condition.term" :condition="condition" :selected="$refs.adviceTable ? $refs.adviceTable.selection : []" />
    <PrintFormDialog :visible.sync="meta.showPrintForm" :hospitalization="entity" :advices="$refs.adviceTable ? $refs.adviceTable.selection : []" :type="meta.printFormType" />
    <!-- </template> -->
  </el-container>
</template>
<script>
import api from "../api";
import { mapGetters } from "sw-hic";

export default {
  props: {
    entity: Object, // 住院记录
  },
  components: {
    AdviceTable: () => import("./_table.vue"), // 医嘱列表
    SpecialEditor: () => import("./dlgSpecial.vue"), // 转科或者出院医嘱画面
    TemplateEditor: () => import("@/components/template/editor.vue"),
    TemplateSelector: () => import("./dlgTmplSelector.vue"),
    PrintDialog: () => import("./dlgPrint.vue"),
    PrintFormDialog: () => import("./dlgPrintForm.vue"),
    //applyBill,
  },
  data() {
    return {
      storehouseCode: "",
      meta: {
        loading: false,
        showHerbal: false,
        showMl: false,
        showDiagnosis: false,
        showBill: true,
        showSpecial: false,
        showPrint: false,
        showPrintForm: false,
        specialType: "转科",
        dateRange: [],
        term: "临时",
        printFormType: null,
      },
      condition: {
        keyword: null,
        pageSize: 20,
        pageIndexOnView: 1,
        sort: "id",
        asc: false,
        ifMasterSlave: true, // 主从模式
        term: "长期", // 上一次保存的医嘱期效
      },
      tmpl: {
        showEditor: false,
        showSelector: false,
        entity: {},
      },
    };
  },
  computed: {
    ...mapGetters(["dict", "Enum", "dictEnum", "user", "permission", "setting"]),
    StorehouseOptions() {
      let list = this.dict.Storehouse.filter((el) => el.forIp && !el.hasHerbal);
      let result = list.map((res, index) => {
        if (index == 0) this.storehouseCode = res.value;
        return {
          label: res.name,
          value: res.value,
        };
      });
      return result;
    },
    readonly() {
      return this.entity?.state == "已离院" || this.entity?.state == "已结算";
    },
  },
  watch: {
    entity() {
      this.init();
    },
  },
  provide() {
    return {
      proto: this.proto,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.condition.hospitalizationId = this.entity.id;
      if (this.$refs.adviceTable) {
        this.$refs.adviceTable.page();
      }
    },
    dateChange(v) {
      if (v) {
        this.$set(this.condition, "createDateStart", this.$utils.Fmt.startDatetime(v[0]));
        this.$set(this.condition, "createDateEnd", this.$utils.Fmt.endDatetime(v[1]));
      } else {
        delete this.condition.createDateStart;
        delete this.condition.createDateEnd;
      }
      this.init();
    },
    proto(opt) {
      return {
        type: opt ? "草药" : "自动",
        term: this.condition.term || this.meta.term, // 查询条件优先
        ipNo: this.entity.ipNo,
        bedNo: this.entity.bedNo,
        patientCode: this.entity.patientCode,
        patientName: this.entity.patientName,
        doctorCode: this.user.code,
        doctorName: this.user.name,
        // execDeptCode:opt == '草药' ? null : this.user.deptCode,
        deptCode: this.user.deptCode,
        state: "草稿",
        startTime: this.$utils.Dt.now(),
        code: opt ? opt.code : null,
        name: opt ? opt.name : null,
        price: opt ? opt.price : null,
        detailObj: opt ? opt : {},
        detail: opt ? JSON.stringify(opt) : null,
        claimType: "医保内",
        hospitalizationId: this.entity.id,
        srcId: opt?.quantity ? opt.id : null, // 如果有库存旧记录库存ID
      };
    },
    action(type, ids) {
      if (!Array.isArray(ids)) {
        ids = null;
      }

      // 执行操作
      ids = (ids || (this.$refs.adviceTable?.selection || []).map((i) => i.id)).filter((i) => !!i);
      if (!ids || !ids.length) {
        this.$message.warning("请选择要操作的医嘱！");
        return;
      }
      api.Advice.action({ ids }, type)
        .then((res) => {
          if (res.success == res.total) {
            this.$message.success("操作成功！");
          } else {
            this.$message.warning(res.message);
          }
          this.$refs.adviceTable.refresh(ids);
        })
        .catch((err) => {
          this.$message.error(err.message || err);
        });
    },
    special(cmd) {
      switch (cmd) {
        case "医技":
          this.meta.showMl = true;
          break;
        case "草药":
          this.meta.showHerbal = true;
          break;
        case "离院":
        case "转科":
          this.meta.specialType = cmd;
          this.meta.showSpecial = true;
          break;
      }
    },
    addAdvice(info, noRefresh) {
      console.log('医嘱info===',info)      
      this.meta.loading = true;
      this.meta.term = info.term;
      api.Advice.save(info)
        .then((res) => {
          if (!info.id && (info.type == '药品' || info.type == '草药'|| info.type == '医技')) {
            let adviceIssued = {};
            adviceIssued.rpClass = info.rpClass;
            adviceIssued.adviceType = info.type;
            adviceIssued.storehouseCode = info.storehouseCode;
            adviceIssued.code = info.code;
            adviceIssued.name = info.name;
            adviceIssued.detail = info.detail;
            api.AdviceIssued.save(adviceIssued);
          }

          this.$message.success("操作成功");
          // 新建时候加上开具log, 从医嘱不用加
          if (!res.groupNo) {
            api.Advice.action({ ids: [res.id] }, "开具");
          }
          if (!noRefresh) {
            this.init();
          }
        })
        .catch((err) => {
          this.$message.error(err.message || err);
        })
        .finally(() => {
          this.meta.loading = false;
        });
    },
    mlSelected(data) {
      data.forEach((option, index) => {
        let draft = this.proto();
        this.$utils.Obj.propertyCopy(option, draft, ["rpClass", "code", "insuranceCode", "claimType", "name", "standard", "unit", "quantity", "approvalNumber", "lotNumber", "form", "manufacturerCode", "feeType", "restrict", "cost", "price", "frequency", "times", "dosagePerTime", "dosageUnit", "totalDose", "usage", "drops", "itemType", "symptom", "parts", "checkWays", "execDeptCode", "content", "ifHomeDrug", "ifOneTimeCharge", "ifStandby", "decoction", "dosage", "contraindication", "specialUsage", "purpose", "ifEmergency", "specimenType", "storehouseCode"], this);
        this.$set(draft, "detail", JSON.stringify(option));
        this.$set(draft, "id", null);
        this.$set(draft, "type", "医技");
        this.addAdvice(draft, index < data.length - 1);
      });
    },
    hearbalSelected(data) {
      data.type = "草药";
      api.Advice.Herbal.save(data).then((res) => {
        this.$message.success("操作成功");
        this.init();
      });
    },
    print(type) {
      if (type) {
        this.meta.printType = type;
      } else {
        this.meta.printType = this.condition.term;
      }
      this.meta.showPrint = true;
    },
    printForm(cmd) {
      if (cmd == "检验申请单" || cmd == "检验条码") {
        if (!this.$refs.adviceTable.selection.length) return this.$message.warning("至少要选中一条医嘱！");
        if (this.$refs.adviceTable.selection.filter((item) => item.state != "启用" && item.state != "停止" && item.state != "待停止" && item.state != "待校对").length) return this.$message.warning("只允许下达后的医嘱！");
        if (this.$refs.adviceTable.selection.filter((item) => item.rpClass != "检验").length) return this.$message.warning("只允许选择 检验 类型的医嘱！");
        this.meta.printFormType = cmd;
        this.meta.showPrintForm = true;
      }
    },
    tmplCmd(cmd) {
      if (cmd == "save") {
        if (!this.$refs.adviceTable?.selection || !this.$refs.adviceTable.selection.length) {
          return this.$message.error("请至少选择1条医嘱!");
        }
        this.tmpl.entity = {
          items: this.$refs.adviceTable.selection.map((item) => this.$utils.Obj.clone(item)),
        };
        this.tmpl.showEditor = true;
      } else if (cmd == "select") {
        this.tmpl.showSelector = true;
      } else if (cmd == "checkApp") {
        this.printForm("检验申请单");
      } else if (cmd == "checkQr") {
        this.printForm("检验条码");
      }
    },
  },
};
</script>
